import _regeneratorRuntime from "/nfs-data/jenkins-slave/nonlive/workspace/sg_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _classCallCheck from "/nfs-data/jenkins-slave/nonlive/workspace/sg_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/nfs-data/jenkins-slave/nonlive/workspace/sg_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/createClass.js";
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var Env;
(function (Env) {
  Env["NonLive"] = "test";
  Env["Live"] = "live";
})(Env || (Env = {}));
var CDNHost = {
  CN: 'https://deo.shopeesz.com',
  Other: 'https://cs.deo.shopeemobile.com'
};
var canCreateDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
/**
 * Get bucket in CDN:
 *    Live: shopee-cschannelcomponents-live-all
 *    Non-Live: shopee-cschannelcomponents-test-all
 * @param env Evn
 * @returns bucket name on CDN
 */
function getBucket(env) {
  var serve = env === Env.Live ? Env.Live : Env.NonLive;
  var deployProjectName = 'cssharedcomponent';
  return "shopee-".concat(deployProjectName, "-").concat(serve, "-all");
}

/**
 * Get prefix of script link. As Store all packages on CDN, with buckets:
 *    Live: shopee-cschannelcomponents-live-all
 *    Non-Live: shopee-cschannelcomponents-test-all
 * @param env Evn
 * @param region region
 * @returns prefix of packages's output script link on CDN
 */
function getPrefix(env, region) {
  var isCN = (region || '').toLocaleLowerCase() === 'cn';
  var bucket = getBucket(env);
  return isCN ? "".concat(CDNHost.CN, "/shopee/").concat(bucket, "/") : "".concat(CDNHost.Other, "/shopee/").concat(bucket, "/");
}
/**
 * Get script file name
 * @param module module name
 * @param version version of module
 * @returns file name of package's output script
 */
function getScritName(module, version) {
  return (version || '').trim().length > 0 ? "".concat(module, "-").concat(version, ".js") : "".concat(module, ".js");
}
/**
 * Get link of module on CDN.
 * If `env` is not 'live', returns link without version, with version otherwise.
 * @param env Env
 * @param region region
 * @param module module name
 * @param version version of module. Only env is live takes effect
 * @returns script link on CDN of module
 */
function getScriptLink(env, region, module, version) {
  var prefix = getPrefix(env, region);
  var fileName = getScritName(module, version);
  return "".concat(prefix).concat(fileName, "?timestamp=").concat(Date.now());
}
function convertKeysToCamelCase(obj) {
  var result = {};
  for (var key in obj) {
    var camelCaseKey = key.replace(/-([a-z])/g, function (_, letter) {
      return letter.toUpperCase();
    }).replace(/Dialog$/, '');
    result[camelCaseKey] = obj[key];
  }
  return result;
}
var Bootstrap = /*#__PURE__*/function () {
  function Bootstrap() {
    _classCallCheck(this, Bootstrap);
  }
  _createClass(Bootstrap, [{
    key: "load",
    value: function load(props) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;
        var _ref, env, region, modules, result, componentsParams, promises;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = props || {}, env = _ref.env, region = _ref.region, modules = _ref.modules;
                result = {}; // 同步加载 'components' 模块
                componentsParams = {
                  env: env,
                  region: region,
                  module: 'fundamental',
                  version: '1.0.5'
                };
                _context.next = 5;
                return this.loadModule(componentsParams, result);
              case 5:
                // 并行加载其他模块
                promises = modules.filter(function (item) {
                  return item.name !== 'fundamental';
                }).map(function (item) {
                  var name = item.name,
                    version = item.version;
                  var params = {
                    env: env,
                    region: region,
                    module: name,
                    version: version
                  };
                  return _this.loadModule(params, result);
                });
                _context.next = 8;
                return Promise.all(promises);
              case 8:
                return _context.abrupt("return", convertKeysToCamelCase(result));
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "loadModule",
    value: function loadModule(params, result) {
      var module = params.module,
        version = params.version;
      var scriptId = "self-tools-".concat(module, "-").concat(version);
      var existingScript = document.getElementById(scriptId);
      // 对应id的script存在则不再挂载
      if (existingScript) {
        result[module] = true;
        return Promise.resolve(result[module]);
      }
      var url = getScriptLink(params.env, params.region, module, version);
      if (!canCreateDOM) {
        Promise.reject(new Error("Load script failed for don't support 'createElement'"));
        return;
      }
      var script = document.createElement('script');
      script.async = true;
      script.src = url;
      script.id = scriptId;
      return new Promise(function (resolve, reject) {
        script.onload = function () {
          result[module] = true;
          resolve(result[module]);
        };
        script.onerror = function (e) {
          console.error("Failed to load module '".concat(module, "'"));
          result[module] = false;
          reject();
        };
        document.body.appendChild(script);
      });
    }
  }]);
  return Bootstrap;
}();
var index = new Bootstrap();
export { index as default };